import { PropsFromClass, registry } from "@lukekaalim/act-three";
import { BufferGeometry, Camera, Group, Mesh, Object3D, Scene, ShaderMaterial, Uniform, Vector2, Vector2Like, WebGLRenderer } from "three";

/**
 * A TileMaterial is very similar to the standard Shader Material,
 * except that a tilePosition uniform is present. If the TileMaterial
 * is assigned to a Tile, then the tilePosition will be copied
 * from the Tile to the TileMaterial each frame.
 */
export class TileMaterial extends ShaderMaterial {
  uniforms: {
    tilePosition: Uniform<Vector2>,
  } = {
    tilePosition: new Uniform(new Vector2())
  }

}

export class Tile extends Mesh {
  tilePosition: Vector2 = new Vector2();

  material: TileMaterial = new TileMaterial()

  onBeforeRender(): void {
    // The Mesh's tile position is mutably written to the currently
    // rendering TileMaterial.
    this.material.uniforms.tilePosition.value.copy(this.tilePosition);
    this.material.uniformsNeedUpdate = true;
  }
}

declare module "@lukekaalim/act-three" {
  interface ExtendedPrimitives {
    tile: PropsFromClass<Mesh> & { tilePosition?: Vector2Like, material?: TileMaterial }
  }
}

registry.registerPrimitive('tile', () => new Tile(), (tile, { tilePosition }) => {
  tile.tilePosition.copy(tilePosition || { x: 0, y: 0 });
})